export interface PageMeta {
  title: string;
  description: string;
  canonicalPath: string;
}

export const siteUrl = 'https://www.a2s-sarl.com';

export const pageMeta = {
  home: {
    title: 'A2S SARL Maroc - Solutions industrielles et Maintenance',
    description:
      'Améliorez votre production avec A2S SARL : maintenance industrielle, travaux d’électricité, compresseurs d’air et fournitures industrielles au Maroc.',
    canonicalPath: '/'
  },
  services: {
    title: 'Solutions industrielles et Maintenance - A2S.Sarl Maroc',
    description:
      'Découvrez nos services : maintenance industrielle, électricité, compresseurs et fournitures au Maroc.',
    canonicalPath: '/services'
  },
  projects: {
    title: 'Nos projets - A2S Sarl',
    description:
      'Découvrez nos réalisations et notre expertise à travers nos projets au Maroc.',
    canonicalPath: '/projects'
  },
  projectDetail: {
    title: 'Détail Projet - A2S SARL',
    description: 'Détails complets de nos réalisations industrielles au Maroc.',
    canonicalPath: '/projects/[id]'
  },
  about: {
    title: 'À propos de A2S.Sarl - Solutions industrielles et Maintenance',
    description:
      'À propos de A2S.Sarl : spécialiste en maintenance industrielle et solutions techniques au Maroc. Expertise, qualité et accompagnement.',
    canonicalPath: '/about'
  },
  contact: {
    title: 'Contact A2S SARL | Solutions industrielles et Maintenance',
    description:
      'Contactez A2S SARL pour maintenance, électricité et équipements au Maroc. Réponse rapide !',
    canonicalPath: '/contact'
  },
  quote: {
    title: 'Demande de devis - A2S SARL Maroc',
    description:
      'Demandez un devis personnalisé pour vos besoins en maintenance industrielle, électricité, compresseurs d’air et solutions techniques au Maroc.',
    canonicalPath: '/quote'
  },
  blog: {
    title: 'Blog A2S SARL | Guides maintenance et solutions industrielles',
    description:
      'Consultez les guides A2S SARL sur la maintenance industrielle, le traitement des eaux, les compresseurs d’air, l’électricité et les solutions industrielles au Maroc.',
    canonicalPath: '/blog'
  },
  shop: {
    title: 'Boutique en ligne - A2S SARL Maroc',
    description:
      'Découvrez la boutique A2S SARL : équipements et fournitures industrielles au Maroc pour les professionnels. Demandez votre devis en ligne, livraison et retrait en boutique.',
    canonicalPath: '/boutique'
  },
  shopCategory: {
    title: 'Catégorie - Boutique A2S SARL',
    description:
      'Parcourez cette catégorie de produits de la boutique A2S SARL au Maroc.',
    canonicalPath: '/boutique/categorie/[slug]'
  },
  shopProduct: {
    title: 'Produit - Boutique A2S SARL',
    description: 'Fiche produit de la boutique A2S SARL au Maroc.',
    canonicalPath: '/boutique/[slug]'
  },
  cart: {
    title: 'Ma demande de devis - Boutique A2S SARL',
    description:
      'Consultez les produits de votre demande de devis avant de l’envoyer à A2S SARL.',
    canonicalPath: '/boutique/panier'
  },
  checkout: {
    title: 'Demande de devis - Boutique A2S SARL',
    description:
      'Finalisez votre demande de devis sur la boutique A2S SARL.',
    canonicalPath: '/boutique/commande'
  },
  orderConfirmation: {
    title: 'Demande de devis envoyée - Boutique A2S SARL',
    description: 'Votre demande de devis a bien été enregistrée.',
    canonicalPath: '/boutique/commande/confirmation'
  },
  notFound: {
    title: 'Page introuvable - A2S SARL',
    description:
      'La page demandée est introuvable. Retrouvez les services, projets et solutions industrielles de A2S SARL au Maroc.',
    canonicalPath: '/'
  }
} satisfies Record<string, PageMeta>;

export const serviceMeta: Record<string, PageMeta> = {
  maintenance: {
    title: 'Service Maintenance Industrielle au Maroc - A2S.Sarl',
    description:
      'Optimisez la performance de vos équipements avec le service de maintenance industrielle au Maroc proposé par A2S.Sarl : expertise technique, interventions rapides et solutions fiables adaptées à vos besoins.',
    canonicalPath: '/services/maintenance'
  },
  waterTreatment: {
    title: 'Service Traitement des Eaux Usées et Assainissement au Maroc - A2S.Sarl',
    description:
      'Optimisez la gestion de vos eaux usées avec le service de traitement et d’assainissement d’A2S.Sarl : solutions efficaces, conformes aux normes et adaptées aux besoins industriels et environnementaux.',
    canonicalPath: '/services/water-treatment'
  },
  pools: {
    title: 'Fourniture et installation des équipements de piscines au Maroc - A2S.Sarl',
    description:
      'Améliorez votre piscine avec la fourniture et l’installation d’équipements sur mesure par A2S.Sarl : solutions fiables, performantes et adaptées à vos besoins.',
    canonicalPath: '/services/pools'
  },
  renovation: {
    title: 'Rénovation des bâtiments industriels et habitation au Maroc - A2S.Sarl',
    description:
      'Modernisez vos bâtiments industriels et habitations avec A2S.Sarl : solutions de rénovation sur mesure, durables et adaptées à vos besoins.',
    canonicalPath: '/services/renovation'
  },
  industrialSupply: {
    title: 'Fourniture Industrielle au Maroc - A2S.Sarl',
    description:
      'Optimisez vos opérations avec la fourniture industrielle proposée par A2S.Sarl : articles de mécanique industrielle, articles d’automatisme et outillage professionnel.',
    canonicalPath: '/services/industrial-supply'
  },
  airCompressors: {
    title: 'Compresseurs d’Air au Maroc - A2S.Sarl',
    description:
      'Améliorez vos performances avec les compresseurs d’air proposés par A2S.Sarl : équipements fiables, puissants et adaptés à vos besoins industriels.',
    canonicalPath: '/services/air-compressors'
  }
};

export const blogPostMeta: Record<string, PageMeta> = {
  maintenance: {
    title: 'Maintenance industrielle au Maroc - Guide A2S.Sarl',
    description:
      'Découvrez comment prévenir les pannes, optimiser la production et réduire les coûts grâce à une maintenance industrielle efficace avec A2S.Sarl.',
    canonicalPath: '/blog/maintenance'
  },
  waterTreatment: {
    title: 'Traitement des eaux usées et assainissement - A2S.Sarl',
    description:
      'Comprenez les étapes du traitement des eaux usées et les solutions modernes d’assainissement pour protéger la santé, l’environnement et les ressources en eau.',
    canonicalPath: '/blog/water-treatment'
  },
  pools: {
    title: 'Équipements de piscines au Maroc - Guide A2S.Sarl',
    description:
      'Découvrez comment choisir les équipements essentiels de piscine : filtration, traitement de l’eau, éclairage, sécurité et accessoires adaptés.',
    canonicalPath: '/blog/pools'
  },
  renovation: {
    title: 'Rénovation de bâtiments industriels et habitations - A2S.Sarl',
    description:
      'Modernisez vos bâtiments industriels et habitations avec des solutions de rénovation qui améliorent confort, sécurité et performance énergétique.',
    canonicalPath: '/blog/renovation'
  },
  industrialSupply: {
    title: 'Fournitures industrielles au Maroc - Guide A2S.Sarl',
    description:
      'Découvrez les types de fournitures industrielles et comment bien les choisir pour assurer la continuité, la sécurité et la performance de vos opérations.',
    canonicalPath: '/blog/industrial-supply'
  },
  airCompressors: {
    title: 'Compresseurs d’air au Maroc - Types et applications',
    description:
      'Comprenez les types de compresseurs d’air, leur fonctionnement, leurs applications industrielles et les critères pour choisir le modèle adapté.',
    canonicalPath: '/blog/air-compressors'
  },
  maintenanceGmao: {
    title: 'GMAO et maintenance industrielle efficace - A2S.Sarl',
    description:
      'Découvrez comment la GMAO aide à planifier les interventions, suivre les équipements, réduire les pannes et améliorer la productivité industrielle.',
    canonicalPath: '/blog/maintenance-gmao'
  },
  electricalWorks: {
    title: 'Travaux d’électricité au Maroc - Installation et dépannage',
    description:
      'Découvrez les types de travaux d’électricité, les normes à respecter et les bonnes pratiques pour des installations fiables et sécurisées.',
    canonicalPath: '/blog/electrical-works'
  }
};

export const getCanonicalUrl = (canonicalPath: string) => `${siteUrl}${canonicalPath}`;

/**
 * Canonical URL for a product page.
 *
 * Always build this from the slug the API returned, never from the URL param —
 * that is what consolidates a stale/renamed slug onto the real product, and is
 * the strongest canonicalisation signal available to a client-rendered SPA.
 */
export const getShopProductCanonical = (slug: string) =>
  getCanonicalUrl(`/boutique/${slug}`);

export const getShopCategoryCanonical = (slug: string) =>
  getCanonicalUrl(`/boutique/categorie/${slug}`);
